module.exports = __webpack_public_path__ + "img/welcome_img2.e74bde84.png";